import * as React from "react";
import styled, { css } from "styled-components";
import * as _ from "lodash";

import { useDrop } from "src/core/drops/hooks";
import { media } from "src/library/utils/styled-media-queries";
import Grid from "src/library/components/Hedron";
import { Text } from "src/library/components/Text/Text";
import {
  PromotionalTagRequestName,
  usePromotionalTagApi
} from "src/modules/promotions/api/promotional-tags.api";

import { ProductFilterParams } from "../store/products.reducer";

// install Swiper modules
interface ProductTagFilterProps {
  handleSearch: (searchFilter: ProductFilterParams) => void;
}

const PromotionalTagFilter: React.ReactFCWithChildren<ProductTagFilterProps> = ({ handleSearch }) => {
  const [ getPromotionTagsResponse, getPromotionTags ] = usePromotionalTagApi(PromotionalTagRequestName.GET_PROMOTIONAL_TAGS_BY_BRANCH);
  const [ selectedTags, setSelectedTags ] = React.useState<number[] | null>(null);
  const [ { drop } ] = useDrop();

  React.useEffect(() => {
    // get product categories on mount
    if (drop?.id) {
      getPromotionTags({ branchId: drop.id });
    }
  }, [ drop?.id ]);

  React.useEffect(() => {
    if (selectedTags) {
      const filters: ProductFilterParams = { promotionalTags: selectedTags };

      handleSearch(filters);
    }
  }, [ selectedTags ]);

  if (!getPromotionTagsResponse.data?.length) {
    return null;
  }

  return (
    <>
      <TableTagsWrapper>
        <Text
          className="explore-text"
          fontSize="h4"
          weight="bold"
        >
          Explore:
        </Text>

        {_.map(getPromotionTagsResponse.data, promotionTag => (
          <Tag
            key={`promotion-tag-${promotionTag.id}`}
            className={`${(selectedTags || []).includes(promotionTag.id) ? "active" : ""}`}
            tagColor={promotionTag?.color}
            onClick={() => {
              setSelectedTags(currentTags => {
                const existingTagIndex = _.findIndex(currentTags, tagId => tagId === promotionTag.id);

                if (existingTagIndex === -1) {
                  return [ ...(currentTags || []), promotionTag.id ];
                } else {
                  (currentTags || []).splice(existingTagIndex, 1);

                  return [ ...(currentTags || []) ];
                }
              });
            }}
          >
            <Text
              className="tag"
              as="strong"
              color="white"
            >
              {promotionTag.label}
            </Text>
          </Tag>
        ))}
      </TableTagsWrapper>

    </>

  );
};

const Tag = styled.div<{ tagColor: string }>`
  ${({ tagColor, theme }) => css`
    display: inline-block;
    opacity: 0.5;
    background: ${tagColor};
    white-space: nowrap;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    margin: 0.5rem;
    border: 2px solid transparent; 

    .tag {
      opacity: 1;
    }

    &.active {
      opacity: 1;
      border-color: ${theme.colors.primaryLight}; 
    }

    &:hover {
      opacity: 0.75;
      cursor: pointer;
    }
  `}
`;

const TableTagsWrapper = styled(Grid.Bounds)`
  ${({ theme }) => css`
    border-radius: ${theme.borderRadius};
    padding-top: ${theme.spacing.padding.md};
    flex-direction: column;
    flex-wrap: wrap;
    display: flex;

    .explore-text {
      margin-right: ${theme.spacing.margins.md};
    }

    > div {
      margin-bottom: ${theme.spacing.margins.sm};
      margin-right: ${theme.spacing.margins.sm};

      .dropdown-select, .search-input {
        width: 100%;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    ${media({ gt: theme.breakpoints.sm })} {
      flex-direction: row;

      > div {
        margin-bottom: 0;

        .dropdown-select, .search-input {
          width: 200px;
        }
      }
    }
  `};
`;

export default PromotionalTagFilter;
